/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateMarkupResponse {
    getFixupPrototypeFunction() { return CreateMarkupResponse.fixupPrototype; }

    static newInstance(model: Partial<CreateMarkupResponse>): CreateMarkupResponse {
        let obj = Object.assign(new CreateMarkupResponse(), model);
        CreateMarkupResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateMarkupResponse>): CreateMarkupResponse {
        if (!model) return null;
        return CreateMarkupResponse.newInstance(<CreateMarkupResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateMarkupResponse) {
        if (!obj) return;

        models.CreateMarkupResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateMarkupResponse): boolean {
        Object.setPrototypeOf(obj, CreateMarkupResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Created Rule name
     */
    name: string;

}
